import styled from 'styled-components';
import colors from 'constants/colors';

export const SubHeaderContainer = styled.header`
  position: fixed;
  top: 50px;
  display: flex;
  width: 100%;
  height: 48px;
  background: ${colors.charcoal};
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  color: ${colors.white};
  font-size: 14px;
  font-weight: 600;

  .title {
    display: flex;
    align-items: center;
    line-height: 47px;
    height: 47px;

    .highlight {
      color: ${colors.lightBlue};
      text-decoration: none;
      cursor: pointer;
    }
  }
  
  .buttonContainer {
    display: flex;
    align-items: center;
    height: 100%;

    & > div {
      display: flex;
      margin: 10px 0;
    }
  }
`;